import { render, staticRenderFns } from "./organization-distribute-case.vue?vue&type=template&id=4b28bf3e&scoped=true"
import script from "./organization-distribute-case.vue?vue&type=script&lang=ts"
export * from "./organization-distribute-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28bf3e",
  null
  
)

export default component.exports